











































import { Vue, Component, Prop } from 'vue-property-decorator'

import { Position } from '@/services/geolocation'
import { User } from '@/types/Users'
import { darkenColor, textColor } from '@/util/helpers'

import GmapCustomMarker from 'vue2-gmap-custom-marker'

@Component({
  components: {
    GmapCustomMarker,
  },
})
export default class UserMarker extends Vue {
  
  @Prop(Object) user?: User
  @Prop(Object) location?: Position
  @Prop(String) color?: string
  @Prop(Boolean) isDeviceLocation?: boolean // If true, location is the device location

  hover = false

  get lastUpdated() {
    if (this.location?.timestamp) {
      return this.location.timestamp
    }
    if (this.user?.location?.timestamp) {
      return this.user.location.timestamp
    }
    return ''
  }

  get markerAccuracy() {
    if (this.location?.accuracy) return this.location.accuracy
    if (this.user?.location?.accuracy) {
      return this.user.location.accuracy
    }
    return 0
  }

  get markerLocation() {
    if (this.location) return this.location
    if (this.user?.location) {
      return this.gmapMarker(this.user.location)
    }
    return {
      lat: 0,
      lng: 0,
    }
  }

  get markerColor() {
    if (this.color) return this.color
    if (this.user?.additional_info?.color) {
      return this.user.additional_info.color
    }
    return '#4285f4'
  }

  gmapMarker(position: any) {
    if (position.lat && position.lng) return position
    if (!position.latitude || !position.longitude) return null
    return {
      lat: position.latitude,
      lng: position.longitude,
    }
  }

  darkenColor(color: string, amount: number) {
    return darkenColor(color, amount)
  }

  textColor(color: string) {
    return textColor(color)
  }
}
